import React from 'react';
import Dogovora from '../../components/documenty/dogovor/Dogovora'

function DogovorPage(props) {
    return (
        <>
            <Dogovora />
        </>
    );
}

export default DogovorPage;